import React, {
  useState,
  createContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { useRouter } from "next/router";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import HsnPopup from "../hsn/hsn_dialog";
import { Dialog, Transition } from "@headlessui/react";
import Categorymenu from "@/layout/hsn_categorymenu";
import axios from "axios";
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";
import { LineWave } from "react-loader-spinner";
import IMAGES from "@/public/assets/img";
import Image from "next/image";

export default function MexicoImportSearch() {
  const [open, setOpen] = useState(false);
  const [hsnCategories, setHsnCategories] = useState([]);
  const [hsnAllCategories, setHsnAllCategories] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [APIData, setAPIData] = useState([]);
  const router = useRouter();
  const [show, setShow] = useState(false);
  const [showHsn, setShowHsn] = useState(false);
  const [showMainDropdown, setShowMainDropdown] = useState(true);
  const [showSearchDropdown, setshowSearchDropdown] = useState(true);
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const searchDropDownRef = useRef(null);
  const subCategoryDropDownRef = useRef(null);
  const [isLoadingAllCategories, setIsLoadingAllCategories] = useState(false);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [noDataFoundinSearch, setnoDataFoundinSearch] = useState(false);

  useEffect(
    () => {
      const handleEsc = (event) => {
        if (event.keyCode === 27) {
          setshowSearchDropdown(false);
        }
      };
      window.addEventListener("keydown", handleEsc);
      function handleClickOutside(event) {
        if (
          searchDropDownRef.current &&
          !searchDropDownRef.current.contains(event.target)
        ) {
          setshowSearchDropdown(false);
        }

        if (
          subCategoryDropDownRef.current &&
          !subCategoryDropDownRef.current.contains(event.target)
        ) {
          setShowSubDropdown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("keydown", handleEsc);
      };
    },
    [searchDropDownRef],
    [subCategoryDropDownRef]
  );

  useEffect(() => {
    if (searchTerm.length >= 2) {
      fetchData(searchTerm);
      setnoDataFoundinSearch(false);
    } else {
      setshowSearchDropdown(false);
    }
  }, [searchTerm]);

  const fetchData = async () => {
    setshowSearchDropdown(true);
    setIsLoadingSearch(true);
    setnoDataFoundinSearch(false);

    try {
      const response = await axios.get(
        `${ENDPOINTS.IMPORT_DUTY_API}hts-code/suggest?code=${searchTerm}`,
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      const results = [];
      const search = searchTerm.toLowerCase();

      const mainDataMatches =
        data.htsCode?.toLowerCase().includes(search) ||
        data.description?.toLowerCase().includes(search);

      if (mainDataMatches) {
        results.push(data);
      }
      setAPIData(data);
      setSearchInput(searchTerm);
      setIsLoadingSearch(false);
      setnoDataFoundinSearch(data.length === 0);
    } catch (err) {
      console.error("Search failed:", err);
      setIsLoadingSearch(false);
      setnoDataFoundinSearch(true);
    }
  };

  //function call on category hover end
  function showAllPhoneCategories() {
    setOpen1(true);
    getAllCategories();
  }
  //function all catetories dropdown start
  async function getCategories() {
    setIsLoadingAllCategories(true);
    setShowMainDropdown(true);
    setshowSearchDropdown(false);
    try {
      const response = await axios.get(`${ENDPOINTS.IMPORT_DUTY_API}chapters`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (hsnCategories.length == 0) {
        setIsLoadingAllCategories(false);
      }
      setHsnCategories(response.data);
      setHsnAllCategories(response.data);
      setIsLoadingAllCategories(false);
    } catch (err) {}
  }

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleOnCloseHsn = () => {
    setShowHsn(false);
  };

  async function getAllCategories() {
    try {
      const response = await axios.get(`${ENDPOINTS.IMPORT_DUTY_API}chapters`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setHsnAllCategories(response.data);
    } catch (err) {}
  }

  function highlightText(text = "", highlight = "") {
    if (!text) return null;
    if (!highlight) return text;
    const escapedHighlight = highlight.replace(/[*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="bg-yellow-300 font-bold">
          {part}
        </span>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  }

  const handleChapterClick = () => {
    setShowSubDropdown(false);
    setShowMainDropdown(false);
    setOpen1(false);
    setOpen(false);
  };

  return (
    <>
      <section
        className={[
          "relative sm:z-[10] bg-no-repeat sm:bg-center bg-cover bg-bottom min-h-[270px]",
          router.pathname === "/mexico-import-duty"
            ? "py-14 sm:py-6 md:py-6"
            : "pt-16 sm:pt-20 pb-12 sm:pb-5",
        ].join(" ")}
      >
        <Image
          priority
          src={IMAGES.ImportFactoring.ImportBGBanner.src}
          width={1366}
          height={550}
          className="absolute inset-0 max-w-none w-full h-full -z-[1]"
          alt="Banner Desktop"
        />

        <div className="container container-small xm:px-2 text-center">
          {router.pathname === "/mexico-import-duty" ? (
            <>
              <p className="text-xxl font-medium text-[#FFFFFF] sm:text-lg sm:mb-xsp">
                Find the HTS Code and get
              </p>
              <h1 className="text-headingbigger mb-1 sm:mb-xsp font-medium sm:text-xxl text-[#FFFFFF] md:text-heading5">
                Mexico Import Duty & Tariffs
              </h1>
              <h2 className="text-xl sm:text-base text-[#FFFFFF] mb-5 sm:mb-3 md:text-lg">
                Import duty % and tariff data for your products Quick, official,
                and easy to understand.
              </h2>
            </>
          ) : (
            <>
              <p className="text-xxl mb-xsp font-medium sm:text-lg text-[#FFFFFF]">
                Find the HTS Code and get Mexico Import Duty & Tariffs
              </p>
              <p className="text-base2 sm:text-base text-[#FFFFFF] mb-2">
                Import duty % and tariff data for your products Quick, official,
                and easy to understand.
              </p>
            </>
          )}

          <div className="sm:w-full w-[800px] md:w-full m-auto relative">
            <div className="flex items-start justify-between md:justify-center relative z-[51]">
              <div className="sm:w-[15%] md:w-[10%]">
                <Menu as="div" className="inline-block text-left">
                  <div>
                    <Menu.Button
                      onClick={getCategories}
                      className="inline-flex md:hidden sm:hidden sm:w-full w-[177px] justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50"
                    >
                      <span>All Categories</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"></path></svg>
                    </Menu.Button>
                    <div className="hidden sm:block md:block justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp md:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 sm:h-[50px] sm:w-[100%]">
                      <div className="flex items-center">
                        <span className="sr-only">Open main menu</span>
                        <svg 
                         onClick={showAllPhoneCategories}
                         xmlns="http://www.w3.org/2000/svg" 
                         viewBox="0 0 24 24" 
                         width="36" 
                         height="36" 
                         fill="currentColor" 
                         className="block h-6 w-6 sm:w-full sm:h-6"
                         aria-hidden="true">
                         <path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
                    <Transition.Root show={open1} as={Fragment}>
                      <Dialog
                        as="div"
                        className="relative z-[100]"
                        onClose={setOpen}
                      >
                        <div className="fixed inset-0" />

                        <div className="fixed inset-0 overflow-hidden">
                          <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-14">
                              <Transition.Child
                                as={Fragment}
                                enter="transform transition origin-left ease-in-out duration-300 sm:duration-300"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-300 sm:duration-300"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                              >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                                  <div className="flex h-full flex-col overflow-y-scroll bg-white">
                                    <button
                                      type="button"
                                      className="rounded-md left-[-45px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2 sm:left-1 sm:top-0 sm:z-[99999]"
                                      onClick={() => setOpen1(false)}
                                    >
                                      <span className="sr-only">
                                        Close panel
                                      </span>
                                      <XMarkIcon
                                        className="h-6 w-6 text-white"
                                        aria-hidden="true"
                                      />
                                    </button>
                                    <div className="relative px-0">
                                      <div className="sm:pt-3">
                                        <div className="mt-3 text-center sm:mt-0">
                                          <section className="bg-white">
                                            <div className="container px-2 xm:px-2">
                                              <div className="bg-white sm:w-auto text-left  lg:m-auto">
                                                <div className="mx-auto  sm:w-auto">
                                                  {hsnAllCategories?.map(
                                                    (sectionData) => {
                                                      return (
                                                        <div
                                                          className="border border-bordercolor overflow-hidden rounded-lg mb-2"
                                                          key={sectionData.code}
                                                        >
                                                          <div className="bg-[#EFF5FA] flex justify-between items-center cursor-pointer">
                                                            <Link
                                                              href={`${WEB_URL}/mexico-import-duty/chapter/${sectionData.chapter}`}
                                                              rel="noopener noreferrer"
                                                              onClick={
                                                                handleChapterClick
                                                              }
                                                            >
                                                              <li className="flex cursor-pointer text-sm rounded-md p-1 m-0.5 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                                                                <span className="text-anchor-blue min-w-[80px]">
                                                                  Chapter{" "}
                                                                  {parseInt(
                                                                    sectionData.chapter,
                                                                    10
                                                                  )}
                                                                </span>
                                                                <span className="text-gray-800">
                                                                  {
                                                                    sectionData.description
                                                                  }
                                                                </span>
                                                              </li>
                                                            </Link>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </section>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                    </Transition.Root>
                  </HideCategoryMenuContext.Provider>
                  {showMainDropdown && (
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={`absolute pointer-events-auto left-[0px] z-10 mt-2  min-h-[260px] origin-top-right  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                          showSubDropdown ? "rounded-s-lg" : "rounded-md"
                        }`}
                        onClick={() => setShowSubDropdown(true)}
                      >
                        <>
                          <div className="py-1">
                            <Menu.Item>
                              <ul>
                                {isLoadingAllCategories && (
                                  <li className="text-brand font-medium flex justify-center">
                                    <LineWave
                                      height="100"
                                      width="100"
                                      color="#022b5c"
                                      middleLineColor="#e3a200"
                                      lastLineColor="#022b5c"
                                    />
                                  </li>
                                )}

                                {hsnCategories.map((sectionData) => {
                                  return (
                                    <li
                                      key={sectionData.code}
                                      aria-expanded={
                                        showSubDropdown ? "true" : "false"
                                      }
                                      onClick={() => setShowSubDropdown(false)}
                                      className="text-brand font-medium cursor-pointer"
                                    >
                                      <div className="relative">
                                        <div className="flex items-center justify-between text-sm transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                                          <Link
                                            href={`${WEB_URL}/mexico-import-duty/chapter/${sectionData.chapter}`}
                                            rel="noopener noreferrer"
                                            onClick={handleChapterClick}
                                          >
                                            <li className="flex cursor-pointer text-sm rounded-md py-2 px-3 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                                              <span className="text-anchor-blue mr-1 min-w-[80px]">
                                                Chapter{" "}
                                                {parseInt(
                                                  sectionData.chapter,
                                                  10
                                                )}
                                              </span>
                                              <span className="text-gray-800">
                                                {sectionData.description}
                                              </span>
                                              {/* <span className="text-gray-800 ml-2">
                                                {sectionData.tariff_sections} Sections
                                              </span>
                                              <span className="text-gray-800">
                                                Avg {sectionData.average_tax_rate}
                                              </span> */}
                                            </li>
                                          </Link>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </Menu.Item>
                          </div>
                        </>
                      </Menu.Items>
                    </Transition>
                  )}
                </Menu>
              </div>
              <div className="sm:w-[84%] w-[85%] sm:ml-[1%] ml-[20px]">
                <div className="relative flex items-start">
                  <input
                    value={searchTerm}
                    onChange={handleInputChange}
                    type="text"
                    name="search"
                    id="search"
                    autoComplete="off"
                    placeholder="Search by product name or HS Code (e.g., “Denim fabric” or “6204.32.03”)"
                    className="inline-flex w-[606px] sm:w-full tex-sm sm:text-xs sm:h-[50px] md:h-[50px] md:w-[100%]  md:ml-0 lg:justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none"
                  />
                    <div className="absolute inset-y-0 right-0 flex py-1.5 pr-1.5 bg-white rounded-r-[10px] mt-0.5">
                      <div className="inline-flex items-center px-1 font-sans text-xs text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="currentColor"
                        >
                          <path d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"></path>
                        </svg>
                      </div>
                    </div>
                </div>
              </div>
            </div>

            {showSearchDropdown && (
              <>
                {searchInput.length >= 2 ? (
                  <div
                    ref={searchDropDownRef}
                    className="bg-white drop-shadow z-[50] absolute lg:top-2 max-h-[325px] overflow-auto searchDrodownMobileLeft lg:pt-[32px] lg:ml-[197px] lg:w-[599px] tex-sm sm:h-auto md:w-[85%] sm:w-[83%] md:ml-0 sm:left-[17%] md:left-[15%]"
                  >
                    {noDataFoundinSearch && (
                      <li className="text-brand font-medium flex justify-center py-1">
                        NO DATA FOUND
                      </li>
                    )}

                    {isLoadingSearch && (
                      <li className="text-brand font-medium flex justify-center">
                        <LineWave
                          height="100"
                          width="100"
                          color="#022b5c"
                          middleLineColor="#e3a200"
                          lastLineColor="#022b5c"
                        />
                      </li>
                    )}
                    {APIData.map((result) => {
                      return (
                        <>
                          <Link
                            href={
                              WEB_URL +
                              `/mexico-import-duty/${String(
                                result.code
                              ).replace(/\./g, "")}`
                            }
                          >
                            <div
                              onClick={() => {
                                setshowSearchDropdown(false);
                              }}
                              className="w-full cursor-pointer p-1 flex border-b border-[#00000020]"
                              key={result.code}
                            >
                              <span className="mr-2 text-[12px] h-3 text-white w-[25px] font-medium rounded-sm bg-[#022b5c] p-[3px] flex items-center justify-center">
                                {" "}
                                {result.chapter}
                              </span>
                              <span className="pr-2 text-[14px]">
                                {result.description
                                  ? highlightText(
                                      result.description,
                                      searchInput
                                    )
                                  : null}
                                {result.code != null && (
                                  <span>
                                    {" "}
                                    (
                                    {result.code
                                      ? highlightText(result.code, searchInput)
                                      : null}
                                    )
                                  </span>
                                )}
                              </span>
                            </div>
                          </Link>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
          <p className="text-base2 sm:text-xs text-white text-center mt-2 sm:mt-1">
            Based on official decree data effective from 20 Dec 2024 to 23 Apr
            2026
          </p>
        </div>
      </section>

      <HsnPopup
        onClose={handleOnCloseHsn}
        show={showHsn}
        setShowHsn={(bool) => setShow(bool)}
      />

      {/* /* hsn finder input end */}
      <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
            <div className="fixed inset-0" />
            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                <div className=" fixed inset-y-0 right-0 flex max-w-full pl-14">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-500"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                      <div className="flex h-full flex-col overflow-y-scroll bg-white pt-2 pb-6 shadow-xl">
                        <button
                          type="button"
                          className="rounded-md left-[-40px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon
                            className="h-6 w-6 text-white"
                            aria-hidden="true"
                          />
                        </button>
                        <div className="relative px-0">
                          <Categorymenu open={open} />
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </HideCategoryMenuContext.Provider>
      <HsnPopup
        onClose={handleOnCloseHsn}
        show={showHsn}
        setShowHsn={(bool) => setShow(bool)}
      />
    </>
  );
}

function debounce(func, delay) {
  let timeoutId;
  const debouncedFunction = (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };

  debouncedFunction.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  return debouncedFunction;
}

export const HideCategoryMenuContext = createContext();
